import { useCallback, useState } from 'react';

export const useToggler = (defaultState = true): [boolean, () => void] => {
  const [isToggledPanel, setToggledPanel] = useState(defaultState);
  const handleTogglePanel = useCallback(() => setToggledPanel(!isToggledPanel), [isToggledPanel]);
  return [isToggledPanel, handleTogglePanel];
};
